import { render } from "./student_register.vue?vue&type=template&id=1fd3c256&scoped=true"
import script from "./student_register.vue?vue&type=script&lang=js"
export * from "./student_register.vue?vue&type=script&lang=js"

import "./student_register.vue?vue&type=style&index=0&id=1fd3c256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd3c256"]])

export default __exports__